export function useMapContact(contact, modelValue, isShipper, isNewContact) {

    if(isShipper) {

        contact.title = modelValue.shipper.shipperContactTitle;
        contact.firstName = modelValue.shipper.shipperContactFirstName;
        contact.lastName = modelValue.shipper.shipperContactLastName;
        contact.phone = modelValue.shipper.shipperContactPhone;
        contact.email = modelValue.shipper.shipperContactEmail;
        contact.department = modelValue.shipper.shipperContactDepartment;

        // Update the visible dropdown value
        modelValue.shipper.shipperContactFullName = modelValue.shipper.shipperContactTitle + ' '
            + modelValue.shipper.shipperContactFirstName + ' ' + modelValue.shipper.shipperContactLastName;

        contact.value = modelValue.shipper.shipperContactTitle + ' '
            + modelValue.shipper.shipperContactFirstName + ' ' + modelValue.shipper.shipperContactLastName;

        if(isNewContact) modelValue.shipper.shipperContacts.push(contact)

    } else {

        contact.title = modelValue.consignee.consigneeContactTitle;
        contact.firstName = modelValue.consignee.consigneeContactFirstName;
        contact.lastName = modelValue.consignee.consigneeContactLastName;
        contact.phone = modelValue.consignee.consigneeContactPhone;
        contact.email = modelValue.consignee.consigneeContactEmail;

        modelValue.consignee.consigneeContactFullName = modelValue.consignee.consigneeContactTitle + ' '
            + modelValue.consignee.consigneeContactFirstName + ' ' + modelValue.consignee.consigneeContactLastName;

        contact.value = modelValue.consignee.consigneeContactTitle + ' '
            + modelValue.consignee.consigneeContactFirstName + ' ' + modelValue.consignee.consigneeContactLastName;

        if(isNewContact) modelValue.consignee.consigneeContacts.push(contact)

    }

    return contact;
}
